import {globalWindow} from '../../libs/shared/helpers/src/browser/browserHelpers';
import {isElectron} from '../../libs/shared/helpers/src/environment/platformHelpers';
import {openExternalUrl} from '../../src/services/electron/electronBridgeOutbound';

/** Open any URL in a browser. */
export function openInBrowser(url: string) {
  // Desktop app, standalone.
  if (isElectron()) {
    openExternalUrl(url);
    return;
  }

  // Web.
  const newWindow = globalWindow.open();
  if (!newWindow) {
    return;
  }

  newWindow.opener = null;
  newWindow.location.href = url;
}
